import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { ResetPasswordDialog } from "@/components/forms/users/reset-password";
import { AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import {
	FormCard,
	FormCardAlert,
	FormCardDescription,
	FormCardHeader,
	FormCardTitle,
} from "@/components/ui/form-card";

export const Route = createFileRoute("/_app/users/$userId/reset-password")({
	component: Page,
	params: z.object({
		userId: z.coerce.number(),
	}),
});

function Page() {
	const params = Route.useParams();

	return (
		<div className="grid grid-cols-12 gap-6 px-4 lg:px-6">
			<FormCard className="col-span-12">
				<FormCardHeader>
					<FormCardTitle>Reset Password</FormCardTitle>
					<FormCardDescription>Manually set a new password for this user.</FormCardDescription>
				</FormCardHeader>
				<FormCardAlert variant="destructive">
					<AlertTitle>Are you sure you want to reset this user's password?</AlertTitle>
					<AlertDescription>
						Resetting the password will immediately invalidate the user's current password. They
						will be unable to log in until the new password is shared with them.
					</AlertDescription>
					<div className="mt-2">
						<ResetPasswordDialog userId={params.userId}>
							<Button variant="destructive">Reset Password</Button>
						</ResetPasswordDialog>
					</div>
				</FormCardAlert>
			</FormCard>
		</div>
	);
}
